// Collection page "Read more / Read less" toggle — supports a matching button
// at both the top and bottom of the collapsible content block.
function toggleReadMore(slug) {
  var content = document.getElementById('rm-content-' + slug);
  var btnTop = document.getElementById('rm-btn-top-' + slug);
  var btnBottom = document.getElementById('rm-btn-bottom-' + slug);
  if (!content || !btnTop) return;

  var isHidden = content.style.display === 'none' || content.style.display === '';
  var brandName = btnTop.getAttribute('data-brand') || '';
  var openText = 'Read more about ' + brandName + ' \u25BC';
  var closeText = 'Read less about ' + brandName + ' \u25B2';

  if (isHidden) {
    content.style.display = 'block';
    btnTop.textContent = closeText;
    if (btnBottom) btnBottom.textContent = closeText;
  } else {
    content.style.display = 'none';
    btnTop.textContent = openText;
    if (btnBottom) btnBottom.textContent = openText;
    // Smoothly scroll back up to the top button so the user isn't left
    // staring at a collapsed block way down the page.
    btnTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
